
































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Inairthreshold from "../../../store/entities/moisturethreshold";
@Component
export default class EditInairthreshold extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  moisturethreshold: Inairthreshold = new Inairthreshold();
  save() {
    (this.$refs.moisturethresholdForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "moisturethreshold/update",
          data: this.moisturethreshold,
        });
        (this.$refs.moisturethresholdForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }else{
          (this.$refs.moisturethresholdForm as any).resetFields();
          this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.moisturethresholdForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.moisturethreshold = Util.extend(true, {}, this.$store.state.moisturethreshold.editMoistureThreshold);
      console.log(this.moisturethreshold);
    }
  }
  moisturethresholdRule = {
    tName: [{ required: true, message: "请填写阈值方案名称", trigger: "blur" }],
    MAX: [{required: true, message: "请填写水分最大值", trigger: "blur" }],
    MIN: [{required: true, message: "请填写水分最小值", trigger: "blur" }],
  };
}
